import type { VoidFunctionComponent } from 'react';

import { Icon, icons } from '../generic';
import DropdownButton from '../generic/DropdownButton';
import type { SortOption } from '../../../shared/organizationPackages/sortOptions';

const sortLabel: Record<SortOption, string> = Object.freeze({
  usage: 'Usage',
  alphabetical: 'Package (A-Z)',
  match: 'Match',
});

type Props = {
  packageName: string;
  sort: SortOption;
  setSort: (sort: SortOption) => void;
};

const PackageSortingDropdown: VoidFunctionComponent<Props> = ({ packageName, sort, setSort }) => {
  return (
    <DropdownButton
      id="PackageSortingDropdown"
      title={
        <span>
          <Icon icon={icons.sortDescending} /> {sortLabel[sort]}
        </span>
      }
      onSelect={setSort}
      size="small"
      pullRight
    >
      {!packageName && (
        <DropdownButton.Item key="alphabetical" eventKey="alphabetical" active={sort === 'alphabetical'}>
          {sortLabel.alphabetical}
        </DropdownButton.Item>
      )}
      {packageName && (
        <DropdownButton.Item key="match" eventKey="match" active={sort === 'match'}>
          {sortLabel.match}
        </DropdownButton.Item>
      )}
      <DropdownButton.Item key="usage" eventKey="usage" active={sort === 'usage'}>
        {sortLabel.usage}
      </DropdownButton.Item>
    </DropdownButton>
  );
};

export default PackageSortingDropdown;
